// extracted by mini-css-extract-plugin
export default {"contactsPage":"style_contactsPage__ezh5k","contactsBlock":"style_contactsBlock__SN-Y8","list":"style_list__9Owlx"};